import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";
import Item from "./Item";
import ProductSidebar from "../components/ProductSidebar";
import { BiUpArrow } from "react-icons/bi";
import { Pagination, Rating, Stack } from "@mui/material";
import "react-loading-skeleton/dist/skeleton.css";
const Category = () => {
  // Destructuring state and functions from the `useStateContext` hook
  const {
    categories,
    CategoriesApiCall,
    singleCategoryDetails,
    setSingleCategoryDetails,
    setIsScrolled,
    singleCategory,
    sidebarOpened,
    cartItem,
    setItemDetail,
    sidebarCartDetail,
    setSidebarCartDetail,
  } = useStateContext();

  // Get the `id` from the route parameters
  const { id } = useParams();

  // Define state variables
  const [loader, setLoader] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;



  // Function to get the current items to display based on pagination
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return singleCategoryDetails.slice(startIndex, endIndex);
  };

  useEffect(() => {
    setItemDetail('');
    // Scroll to the top of the page
    window.scrollTo(0, 0);
    setLoader(true);
    // Reset single category details
    setSingleCategoryDetails([]);

    // Make an API call to fetch categories
    CategoriesApiCall();

    // Fetch details for the single category based on the `id`
    singleCategory(id);
 if(singleCategoryDetails){
  setTimeout(() => {
   setLoader(false);   
  }, 1700);

 }
  console.log(singleCategoryDetails)  
  }, [id]);

  useEffect(() => {
    // Update the sidebar cart detail based on the cart items
    setSidebarCartDetail(false);

    if (cartItem && cartItem.length > 0) {
      setSidebarCartDetail(true);
    } else {
      setSidebarCartDetail(false);
    }

   
  }, [cartItem]);

  // Handle window scroll event
  window.onscroll = () => {
    setIsScrolled(window.pageYOffset === 0 ? false : true);
    return () => (window.onscroll = null);
  };

  // Handle pagination
  const paginate = (event, value) => {
    setCurrentPage(value);

    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Component>
      <FilterSideBar style={{ width: `${sidebarCartDetail ? "15%" : "20%"}` }}>
        <Filter>
          <CategoriesFilter>
            <h3>Categories</h3>

            {categories.map((category, i) => (
              <Link to={`/category/${category.categories_id}`}>
                <p key={i}>{category.title}</p>
              </Link>
            ))}
          </CategoriesFilter>
          <PriceFilter>
            <h3>Price</h3>
            <p>Up to $25</p>
            <p>$25 to $50</p>
            <p>$50 to $100</p>
            <p>$100 to $200</p>
            <p>$200 & above</p>
          </PriceFilter>
          <RatingsFilter>
            <h3>Ratings</h3>
            <div className="rating">
              <Stack spacing={1}>
                <Rating
                  name="half-rating-read"
                  value={4.4}
                  precision={0.1}
                  readOnly
                />
              </Stack>
            </div>
            <div className="rating">
              <Stack spacing={1}>
                <Rating
                  name="half-rating-read"
                  value={4}
                  precision={0.1}
                  readOnly
                />
              </Stack>
            </div>
            <div className="rating">
              <Stack spacing={1}>
                <Rating
                  name="half-rating-read"
                  value={3.4}
                  precision={0.1}
                  readOnly
                />
              </Stack>
            </div>
          </RatingsFilter>
        </Filter>
      </FilterSideBar>
      <Items widthComponent={sidebarCartDetail}>
        {getCurrentItems().length < 0 ? (
          <ItemWrapper>
             
          {[1,2,3,4,7,8,9].map((details, i) => (
            <Loader>
            
         
            </Loader>
          ))}
        </ItemWrapper>
       
        ) : (
      
          <ItemWrapper >
            {getCurrentItems().map((details, i) => (
              <Item
                key={details.categories_id + i}
                details={details}
                categ_id={id}
              />
            ))}
          </ItemWrapper>
          
        )}
        <Stack
          sx={{ mt: { lg: "74px", xs: "70px" } }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {singleCategoryDetails.length > 9 && (
            <Pagination
              color="secondary"
              shape="rounded"
              defaultPage={1}
              count={Math.ceil(singleCategoryDetails.length / itemsPerPage)}
              page={currentPage}
              onChange={paginate}
              size="large"
            />
          )}
        </Stack>
      </Items>
      <CartSideBar
        widthComponent={sidebarCartDetail}
        style={{ zIndex: `${sidebarOpened ? 0 : "1000"}` }}
      >
        <BiUpArrow widthComponent={sidebarCartDetail} className="arrow" />
        <ProductSidebar />
      </CartSideBar>
    </Component>
  );
};

export default Category;

const Component = styled.div`
  margin-top: 10vh;
  width: 100%;
  display: flex;
  margin-bottom: 40px;
`;

const FilterSideBar = styled.div`
  border-right: 1px solid black;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  @media (max-width: 470px) {
    display: none;
  }
`;
const CartSideBar = styled.div`
  max-height: 90vh;
  position: fixed;
  right: 0px;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  overflow-y: auto;
  display: flex;
  box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);
  -webkit-box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);
  -moz-box-shadow: -6px 1px 5px 0px rgba(0, 0, 0, 0.13);
  width: ${(props) => (props.widthComponent ? "10%" : 0)};

  @media (max-width: 470px) {
    width: ${(props) => (props.widthComponent ? "24%" : 0)};
  }
  .arrow {
    font-size: ${(props) => (props.widthComponent ? "21px" : 0)};
    position: fixed;
    top: 7.47vh;
    right: 82px;
    z-index: 4000;
    opacity: 0.4;
    overflow-y: visible;
      @media (max-width: 470px) {
    right: 50px;
                         }
  }
`;

const Items = styled.div`
  min-height: 100vh;
  display: flex;
  margin-top: 2vh;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: ${(props) => (props.widthComponent ? "75%" : "80%")};
  @media (max-width: 470px) {
    width: ${(props) => (props.widthComponent ? "79%" : "100%")};
  }
`;

const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  @media (max-width: 470px) {
    grid-template-columns: 1fr;
  }
`;

const CategoriesFilter = styled.div`
  width: 94%;
  h3 {
    text-align: left;
  }
  .rating {
    margin-left: 40px;
    width: 100%;
  }
  p {
    cursor: pointer;
    color: black;
    font-size: 12px;
    line-height: 12px;
    &:hover {
      text-decoration: underline;
    }
  }
  a {
    text-decoration: none;
  }
`;

const RatingsFilter = styled.div`
  width: 80%;
  .rating {
    transform: scale(0.8);
  }
  p {
    margin-left: 40px;
  }
`;

const PriceFilter = styled.div`
  width: 80%;
  p {
    margin-left: 4px;
    font-size: 13px;
    line-height: 10px;
  }
`;

const Filter = styled.div`
  position: absolute;
  width: 70%;
  top: 20px;

  h3 {
    margin: 0 2px;
  }
`;
const shineAnimation = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 100% 0;
  }
`;


const Loader = styled.div`
  height: ${(props) => (props.widthComponent ? '380px' :'360px' )};
  width: ${(props) => (props.widthComponent ?  '320px': '290px')};
 
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #f4d2e6;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0) 0%,
      #ada9ab 50%,
      rgba(255, 255, 255, 0) 100%
    );
    background-size: 200% 100%;
    background-position: -100% 0;
    animation: ${shineAnimation} 2s linear infinite;
  }
  @media (max-width: 470px) {
    height: ${(props) => (props.widthComponent ? '250px' : '320px')};
    width: ${(props) => (props.widthComponent ? '180px' : '220px')};
  }
`;

